/**
 * Landing selection logic - determines which view component to render
 * Pure utility for selecting the correct renderer based on activeView state
 */

import type { ViewType, AppSection, ActiveView } from "../context/ApplicationContext";

export type { ViewType, AppSection, ActiveView };

/**
 * Determine which view type should be rendered
 * @param activeView - The current active view state
 * @returns The view type to render: "landing" | "component" | "iframe"
 */
export function getViewType(activeView: ActiveView): ViewType {
  if (activeView.type === "component" && activeView.section === "rxLite" && activeView.component) {
    return "component";
  }
  if (activeView.type === "iframe" && activeView.url) {
    return "iframe";
  }
  if (activeView.type === "landing") {
    return "landing";
  }
  // Default to landing for safety
  return "landing";
}

/**
 * Check if view is a landing page view
 */
export function isLandingView(activeView: ActiveView): boolean {
  return getViewType(activeView) === "landing";
}

/**
 * Check if view is an iframe view
 */
export function isIframeView(activeView: ActiveView): boolean {
  return getViewType(activeView) === "iframe";
}

/**
 * Check if view is a component view
 */
export function isComponentView(activeView: ActiveView): boolean {
  return getViewType(activeView) === "component";
}
